module.exports = __webpack_public_path__ + "media/images/footer_youtube-107d36d1624e4fbd4f4e3543c259695f.png";